import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// type Item = { desc: string; price: number };
// export type ReportData = { nombre: string; items: Item[] };

const styles = StyleSheet.create({
  page: { padding: 24, fontSize: 11 },
  title: { fontSize: 18, marginBottom: 12 },
  meta: { marginBottom: 12 },

  table: { borderWidth: 1, borderColor: "#ddd" },
  row: { flexDirection: "row" },
  headerCell: {
    padding: 6,
    fontSize: 11,
    fontWeight: 700,
    borderRightWidth: 1,
    borderRightColor: "#ddd",
  },
  cell: {
    padding: 6,
    borderTopWidth: 1,
    borderTopColor: "#ddd",
    borderRightWidth: 1,
    borderRightColor: "#ddd",
  },

  // 2 columnas
  c1: { width: "70%" },
  c2: { width: "30%", textAlign: "right", borderRightWidth: 0 },

  total: { marginTop: 12, textAlign: "right", fontSize: 12, fontWeight: 700 },
});

export function ReportPdf({ data, total }: { data: any, total: string }) {
//   const total = data.items.reduce((s, i) => s + i.qty * i.price, 0);

    const Currency = (value: string) => {
      const number = PriceToNumber(value);
      return NumberToPrice(number);
    }
    const PriceToNumber = (price: string) => {
      if (!price)
        return 0;
      const number = Number(price.replace(/,/g, ''));
      return number ? number : 0;
    };
    const NumberToPrice = (price: number) => {
      const formatted = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
      }).format(price) + " cop";
      return formatted;
    };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* <Text style={styles.title}>Reporte</Text>
        <Text style={styles.meta}>Cliente: {data.nombre}</Text> */}

        <View style={styles.table}>
          <View style={styles.row}>
            <Text style={[styles.headerCell, styles.c1]}>Descripción</Text>
            <Text style={[styles.headerCell, styles.c2]}>Precio</Text>
          </View>

          {data.map((element: any, index: number) => (
            <View style={styles.row} key={index}>
              <Text style={[styles.cell, styles.c1]}>{element.quote_text}</Text>
              <Text style={[styles.cell, styles.c2]}>{Currency(element.price)}</Text>
            </View>
          ))}
        </View>

        <Text style={styles.total}>Total: {total}</Text>
      </Page>
    </Document>
  );
}
